export default __webpack_public_path__ + "static/media/list.54133424.svg";